module.exports = __webpack_public_path__ + "static/media/empty_cart.1d89687c.png";